export default "__VITE_ASSET__9f4cb471__"